import { RouteComponentProps } from "react-router-dom";

export enum Steps {
  DatosTomador = 1,
  DatosAsegurados = 2,
  Garantias = 3,
  DocumentacionRequerida = 4,
  ProteccionDatos = 5,
  Prima = 6,
  Cuestionarios = 7,
  MetodosPago = 8,
  DetallePrevioContratacion = 9,
}

export interface ForeignersHealthHireMenuProps extends RouteComponentProps<any> {
  initialCurrentStep: Steps;
  initialInsureds: any[]; // => { name?: string, lastname1?: string, lastname2?: string, [x: string]: any }
  codMediador: string;
  selectedMediator?: string;
  insuredSaved?: boolean;
  disableSubButtons?: boolean;
  currentNumInsured?: number;
  isSignedDocument?: boolean;
  isHired?: boolean;
  disableSignButton?: boolean;
  physicalSignature?: boolean;
  policy: any;
  previousOnNavigation?: () => boolean;
  insuredOnAdd?: (insuredSaved: any) => Promise<void>;
  insuredOnRemove?: (index: number) => void;
  insuredOnEdit?: (index: number) => void;
  insuredOnSave?: () => void;
  questionnaireOnEdit?: (index: number) => void;
  questionnaireOnSave?: () => void;
  resumeOnHiring?: () => void;
  downloadPrecontractualDocument?: () => void;
  sendMailPrecontractualDocument?: (showModal?: boolean) => void;
  signPrecontractualDocument?: () => void;
  payHiring?: () => void;
  setLoading?: () => void;
}

export interface ForeignersHealthHireMenuState {
  currentStep: Steps;
  insureds: any[]; // => { name?: string, lastname1?: string, lastname2?: string, [x: string]: any }
  showInsuredsOnDatosAsegurados: boolean;
  showInsuredsOnCuestionarios: boolean;
  mediador: string;
  modal: {
    img: string;
    className: string;
    mainTitle: string;
    mainText: string;
  };
}